/** Matches bot-service DEFAULT_PATROL_KIND_SPEECH_SETTINGS / patrol_guild_config column defaults. */
export const PATROL_KIND_SPEECH_DEFAULTS = {
  kindSpeechEnabled: true,
  kindSpeechMilestoneCount: 10,
  positiveParticipationHourlyLimit: 2,
  kindSpeechPenaltyCooldownMs: 3_600_000,
  kindSpeechDedupeWindowMs: 300_000,
} as const;

export const PATROL_KIND_SPEECH_DEFAULT_PENALTY_MINUTES = Math.round(
  PATROL_KIND_SPEECH_DEFAULTS.kindSpeechPenaltyCooldownMs / 60_000,
);

export const PATROL_KIND_SPEECH_DEFAULT_DEDUPE_MINUTES = Math.round(
  PATROL_KIND_SPEECH_DEFAULTS.kindSpeechDedupeWindowMs / 60_000,
);

export const PATROL_KIND_SPEECH_DEFAULT_I18N_PARAMS = {
  milestone: PATROL_KIND_SPEECH_DEFAULTS.kindSpeechMilestoneCount,
  hourlyLimit: PATROL_KIND_SPEECH_DEFAULTS.positiveParticipationHourlyLimit,
  penaltyMinutes: PATROL_KIND_SPEECH_DEFAULT_PENALTY_MINUTES,
  dedupeMinutes: PATROL_KIND_SPEECH_DEFAULT_DEDUPE_MINUTES,
} as const;
